module.exports = __webpack_public_path__ + "img/wedo_pict02.b195506b.png";